// SidebarAddclientWizard Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import validator from 'validator'

import SidebarAddClientGeneral from '../sidebar_addclient_general/sidebar_addclient_general.jsx'
import SidebarAddClientPeople from '../sidebar_addclient_people/sidebar_addclient_people.jsx'
import SidebarAddClientFinance from '../sidebar_addclient_finance/sidebar_addclient_finance.jsx'
import SidebarProjectHeader from '../layout/sidebar_projectheader/sidebar_projectheader.jsx'

class SidebarAddclientWizard extends Component {
  constructor (props) {
    super(props)

    this.state = this._createStateFromProps(props)
  }

  static get propTypes () {
    return {
      projectName: PropTypes.string,
      clientName: PropTypes.string,
      contact: PropTypes.object,
      onCloseContactSidebar: PropTypes.func,
      onSaveContact: PropTypes.func,
      onClickInfo: PropTypes.func,
      isTeamUSA: PropTypes.bool,
      teamPaymentDays: PropTypes.number,
      addressTypes: PropTypes.array,
      documentLanguages: PropTypes.array,
      defaultRateCards: PropTypes.array,
      teamCountry: PropTypes.string,
      rateMarkup: PropTypes.number
    }
  }

  static get defaultProps () {
    return {
      projectName: '',
      clientName: '',
      contact: null,
      onCloseContactSidebar: null,
      onSaveContact: null,
      onClickInfo: null,
      isTeamUSA: false,
      teamPaymentDays: 0,
      addressTypes: [],
      documentLanguages: [],
      defaultRateCards: [],
      teamCountry: '',
      rateMarkup: 0
    }
  }

  shouldComponentUpdate (nextProps, _nextState) {
    if (!_.isEqual(this.props.contact, nextProps.contact)) {
      const stateObj = this._createStateFromProps(nextProps)
      this.setState(stateObj)
    }
    return true
  }

  _createStateFromProps (props) {
    const { contact, teamCountry } = props
    const defaultAddress = {
      type: '',
      street: '',
      postcode: '',
      streetNumber: '',
      city: '',
      state: '',
      country: teamCountry
    }
    const defaultPerson = {
      name: '',
      email: '',
      phone: ''
    }
    const defaultRateCard = {
      name: '',
      amount: 0
    }

    return {
      currentTab: 'general',
      // Contact Releated
      email: contact ? contact.email : '',
      phone: contact ? contact.phone : '',
      mobile: contact ? contact.mobile : '',
      website: contact ? contact.website : '',
      documentLanguage: contact ? contact.pdfLanguage : '',
      addresses:
        contact && contact.addresses ? contact.addresses : [defaultAddress],
      vatNo: contact ? contact.vatNo : '',
      note: contact ? contact.note : '',
      contactPersons:
        contact && contact.contactPersons && contact.contactPersons.length > 0
          ? contact.contactPersons
          : [defaultPerson],
      rate: contact ? contact.rate : 0,
      rateMarkup:
        contact && contact.rateMarkup
          ? contact.rateMarkup
          : this.props.rateMarkup,
      paymentDays: contact ? contact.paymentDays : this.props.teamPaymentDays,
      rateCards:
        contact && contact.rateCards ? contact.rateCards : [defaultRateCard],
      // Errors
      isErrorEmail: false
      // Others
    }
  }

  getValueAsWebsite (val) {
    if (
      val &&
      val.toLowerCase().indexOf('http://') === -1 &&
      val.toLowerCase().indexOf('https://') === -1
    ) {
      return `https://${val}`
    }

    return val
  }

  _isContactValid () {
    const { clientName } = this.props
    const { email } = this.state
    if (clientName && (!email || validator.isEmail(email))) {
      return true
    }

    return false
  }

  render () {
    return (
      <div className='sidebar-addclient'>
        <div className='sidebarwrap'>
          {this._renderHeader()}
          {this._renderContent()}
        </div>
      </div>
    )
  }

  _renderHeader () {
    const { onCloseContactSidebar, projectName, clientName } = this.props
    const { currentTab } = this.state

    const tabs = [
      {
        ident: 'general',
        title: 'projectV2.header.labelGeneral'
      },
      {
        ident: 'people',
        title: 'projectV2.header.labelPeople'
      },
      {
        ident: 'finance',
        title: 'projectV2.header.labelFinancial'
      }
    ]

    return (
      <SidebarProjectHeader
        icon='edit'
        tabs={tabs}
        activeTab={currentTab}
        showInfo
        showProjectInfo={false}
        projectName={projectName}
        clientName={clientName}
        onSave={this._onSaveContact} // eslint-disable-line react/jsx-handler-names
        onClickInfo={this._onClickInfo} // eslint-disable-line react/jsx-handler-names
        onChangeTab={this._onHeaderTabChange} // eslint-disable-line react/jsx-handler-names
        onClose={onCloseContactSidebar}
        isActive={this._isContactValid()}
        showSaveButton={false}
      />
    )
  }

  _renderContent () {
    const {
      isTeamUSA,
      addressTypes,
      documentLanguages,
      defaultRateCards
    } = this.props
    const { currentTab } = this.state

    return (
      <div className='addclient_wizard'>
        {currentTab === 'general' && (
          <SidebarAddClientGeneral
            contact={this.state}
            isTeamUSA={isTeamUSA}
            addressTypes={addressTypes}
            documentLanguages={documentLanguages}
            onChange={this._onChangeTabGeneral} // eslint-disable-line react/jsx-handler-names
          />
        )}
        {currentTab === 'people' && (
          <SidebarAddClientPeople
            contactPersons={this.state.contactPersons}
            onChange={this._onChangeTabGeneral} // eslint-disable-line react/jsx-handler-names
          />
        )}
        {currentTab === 'finance' && (
          <SidebarAddClientFinance
            contact={this.state}
            defaultRateCards={defaultRateCards}
            onChange={this._onChangeTabGeneral} // eslint-disable-line react/jsx-handler-names
          />
        )}
      </div>
    )
  }

  _onHeaderTabChange = tab => {
    this.setState({ currentTab: tab.ident })
  }

  _onChangeTabGeneral = (name, value) => {
    this.setState({ [name]: value })
  }

  _onClickInfo = () => {
    const { projectName, onClickInfo } = this.props
    if (projectName && onClickInfo) {
      onClickInfo()
    }
  }

  _getContactData () {
    const {
      email,
      phone,
      mobile,
      website,
      addresses,
      vatNo,
      note,
      documentLanguage,
      contactPersons,
      rate,
      rateMarkup,
      paymentDays,
      rateCards
    } = this.state

    return {
      email: email,
      phone: phone,
      mobile: mobile,
      website: this.getValueAsWebsite(website),
      addresses: addresses,
      pdfLanguage: documentLanguage,
      vatNo: vatNo,
      note: note,
      contactPersons: contactPersons,
      rate: rate,
      rateMarkup: rateMarkup,
      paymentDays: paymentDays,
      rateCards: rateCards
    }
  }

  _onSaveContact = () => {
    const contactData = this._getContactData()

    // Filter the contact persons which has valid name and email
    contactData.contactPersons = _.filter(
      contactData.contactPersons,
      person => {
        if (!person.name || !person.email || !validator.isEmail(person.email)) {
          return false
        }
        return true
      }
    )

    // Filter Rate cards which has proper name and rate value
    contactData.rateCards = _.filter(contactData.rateCards, rateCard => {
      if (!rateCard.name || isNaN(rateCard.amount) || rateCard.amount < 0) {
        return false
      }
      return true
    })

    // Filter Addresses which as proper zipcode, street and country
    /* contactData.addresses = _.filter(contactData.addresses, (address) => {
      if (!address.type || !address.street || !address.country || !address.postcode) {
        return false;
      }
      return true;
    }); */

    if (this.props.onSaveContact) {
      const contactId = this.props.contact ? this.props.contact.id : null
      this.props.onSaveContact(contactId, contactData)
    }
  }
}

export default SidebarAddclientWizard
